// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__Float from "melange/float.js";
import * as Stdlib__Hashtbl from "melange/hashtbl.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Map from "melange/map.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__Set from "melange/set.js";
import * as Stdlib__String from "melange/string.js";

const Ids = Stdlib__Set.Make({
  compare: Stdlib__String.compare
});

const By_id = Stdlib__Map.Make({
  compare: Stdlib__String.compare
});

function merge(old, incoming) {
  const add = function (map, s) {
    return Curry._3(By_id.add, s.id, s, map);
  };
  return Stdlib__List.map((function (prim) {
    return prim[1];
  }), Curry._1(By_id.bindings, Stdlib__List.fold_left(add, Stdlib__List.fold_left(add, By_id.empty, old), incoming)));
}

function contains(query, text) {
  const needle = Stdlib__String.lowercase_ascii(Stdlib__String.trim(query));
  if (needle === "") {
    return true;
  }
  const hay = Stdlib__String.lowercase_ascii(text);
  const n = needle.length;
  const h = hay.length;
  let _i = 0;
  while (true) {
    const i = _i;
    if ((i + n | 0) > h) {
      return false;
    }
    if (Stdlib__String.sub(hay, i, n) === needle) {
      return true;
    }
    _i = i + 1 | 0;
    continue;
  };
}

function rows(queryOpt, collapsed, selected, sessions) {
  const query = queryOpt !== undefined ? queryOpt : "";
  const children = Stdlib__Hashtbl.create(undefined, Stdlib__List.length(sessions));
  Stdlib__List.iter((function (s) {
    const previous = Stdlib__Option.value(Stdlib__Hashtbl.find_opt(children, s.parent_id), /* [] */ 0);
    Stdlib__Hashtbl.replace(children, s.parent_id, {
      hd: s,
      tl: previous
    });
  }), sessions);
  const info = Stdlib__Hashtbl.create(undefined, Stdlib__List.length(sessions));
  const measure = function (s) {
    const nested = Stdlib__Option.value(Stdlib__Hashtbl.find_opt(children, s.id), /* [] */ 0);
    const match = Stdlib__List.fold_left((function (param, child) {
      const match = measure(child);
      return [
        Caml.caml_float_max(param[0], match[0]),
        param[1] || match[1]
      ];
    }), [
      s.created_at,
      Caml_obj.caml_equal(s.id, selected)
    ], nested);
    const active = match[1];
    const latest = match[0];
    Stdlib__Hashtbl.add(info, s.id, [
      latest,
      active
    ]);
    return [
      latest,
      active
    ];
  };
  const roots = Stdlib__Option.value(Stdlib__Hashtbl.find_opt(children, undefined), /* [] */ 0);
  Stdlib__List.iter((function (s) {
    measure(s);
  }), roots);
  const compare = function (a, b) {
    const match = Stdlib__Hashtbl.find(info, a.id);
    const match$1 = Stdlib__Hashtbl.find(info, b.id);
    const chosen = Caml.caml_int_compare(match$1[1], match[1]);
    if (chosen !== 0) {
      return chosen;
    }
    const date = Caml.caml_float_compare(match$1[0], match[0]);
    if (date !== 0) {
      return date;
    } else {
      return Caml.caml_string_compare(b.id, a.id);
    }
  };
  const subtree = function (s) {
    if (contains(query, s.title)) {
      return true;
    } else {
      return Stdlib__List.exists(subtree, Stdlib__Option.value(Stdlib__Hashtbl.find_opt(children, s.id), /* [] */ 0));
    }
  };
  const matched = function (s) {
    if (query === "") {
      return true;
    } else {
      return subtree(s);
    }
  };
  const flatten = function (level, items, ancestor, acc) {
    return Stdlib__List.fold_left((function (acc, s) {
      const nested = Stdlib__Option.value(Stdlib__Hashtbl.find_opt(children, s.id), /* [] */ 0);
      const self = contains(query, s.title);
      if (query !== "" && !ancestor && !matched(s)) {
        return acc;
      }
      const expanded = query !== "" || !Curry._2(Ids.mem, s.id, collapsed);
      const row_branch = Caml_obj.caml_notequal(nested, /* [] */ 0);
      const row_selected = Caml_obj.caml_equal(s.id, selected);
      const row = {
        session: s,
        level,
        branch: row_branch,
        expanded,
        selected: row_selected
      };
      const acc$1 = {
        hd: row,
        tl: acc
      };
      if (expanded) {
        return flatten(level + 1 | 0, nested, ancestor || self, acc$1);
      } else {
        return acc$1;
      }
    }), acc, Stdlib__List.sort(compare, items));
  };
  return Stdlib__List.rev(flatten(1, roots, false, /* [] */ 0));
}

export {
  Ids,
  merge,
  rows,
}
/* Ids Not a pure module */
